import { render, staticRenderFns } from "./forwarding-center.vue?vue&type=template&id=dcdbb780"
import script from "./forwarding-center.vue?vue&type=script&lang=js"
export * from "./forwarding-center.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports